import { Skeleton } from "antd";

export const SkeletonPetProfileForm = () => {
  return (
    <div className="space-y-8">
      {/* BASIC INFO */}
      <div className="space-y-5">
        <Skeleton.Input active className="!w-48 !h-10" />

        <div className="grid grid-cols-1  gap-5">
          {Array.from({ length: 2 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <Skeleton.Input active className="!w-28 !h-4" />
              <Skeleton.Input active block className="!h-10 !w-full" />
            </div>
          ))}
        </div>
      </div>

      {/* HEALTH */}
      <div className="space-y-5">
        <Skeleton.Input active className="!w-32 !h-10" />

        <div className="grid grid-cols-1  gap-5">
          {Array.from({ length: 2 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <Skeleton.Input active className="!w-32 !h-4" />
              <Skeleton.Input active block className="!h-20 !w-full" />
            </div>
          ))}
        </div>
      </div>

      {/* ROUTINE */}
      <div className="space-y-5">
        <Skeleton.Input active className="!w-36 !h-10" />

        <div className="grid grid-cols-1  gap-5">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <Skeleton.Input active className="!w-32 !h-4" />
              <Skeleton.Input active block className="!h-10 !w-full" />
            </div>
          ))}
        </div>
      </div>

      {/* BEHAVIOR */}
      <div className="space-y-5">
        <Skeleton.Input active className="!w-40 !h-10" />

        <div className="grid grid-cols-1  gap-5">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <Skeleton.Input active className="!w-36 !h-4" />
              <Skeleton.Input active block className="!h-10 !w-full" />
            </div>
          ))}
        </div>
      </div>

      {/* PHOTOS */}
      <div className="space-y-5">
        <Skeleton.Input active className="!w-28 !h-7" />

        <div className="flex gap-3 flex-wrap">
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton.Image
              key={index}
              active
              className="!w-32 !h-32 !rounded-xl"
            />
          ))}
        </div>
      </div>

      {/* ACTIONS */}
      <div className="flex justify-end gap-3 pt-4">
        <Skeleton.Button active className="!w-32 !h-10" />
        <Skeleton.Button active className="!w-28 !h-10" />
      </div>
    </div>
  );
};
